module.exports = __webpack_public_path__ + "static/img/img1.e512171.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/img1.png
// module id = YV5P
// module chunks = 1